// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SuggestionReason-cls1___95772e2a22cd12a5f48{/*!*/}.SuggestionReason-cls2___4f44f60f53920b0507d{display:none;width:12px;text-align:center}@media(min-width: 768px){.SuggestionReason-cls2___4f44f60f53920b0507d{display:inline-block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SuggestionReason-cls1___95772e2a22cd12a5f48",
	"cls2": "SuggestionReason-cls2___4f44f60f53920b0507d SuggestionReason-cls1___95772e2a22cd12a5f48"
};
export default ___CSS_LOADER_EXPORT___;
